export default {
  HEADER: 'HEADER',
  HEADER_MODERN: 'HEADER_MODERN',
  FOOTER: 'FOOTER',
  FOOTER_MODERN: 'FOOTER_MODERN',
  COPYRIGHT: 'COPYRIGHT',
  COPYRIGHT_MODERN: 'COPYRIGHT_MODERN',
  BURGERMETA: 'BURGERMETA',
  BURGERMAIN: 'BURGERMAIN',
  SIDEBAR_DASHBOARD: 'SIDEBAR_DASHBOARD',
  SIDEBAR_USERSETTINGS: 'SIDEBAR_USERSETTINGS',
  DASHBOARD: 'DASHBOARD',
  USERLINKS: 'USERLINKS',
  USERLINKS_MODERN: 'USERLINKS_MODERN',
}
